import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import {
  getSummaryUnderwriterProfilesAsyncV2,
  getUnderwriterProfileAsync,
} from '../../../API/administration/UnderwriterProfileAPI';
import { defaultUnderwriterProfileData } from '../../../types/administration/pricing/underwriterProfileInterfaces/IUnderwriterProfile';

export const { slice: getSummaryUnderwriterProfilesV2Slice, asyncAction: getSummaryUnderwriterProfilesV2Action } =
  createAsyncSliceWithDataAndQuery('getUnderwriterProfilesV2', getSummaryUnderwriterProfilesAsyncV2, []);

export const { slice: getUnderwriterProfileDetailSlice, asyncAction: getUnderwriterProfileAsyncAction } =
  createAsyncSliceWithDataAndQuery(
    'getUnderwriterProfileDetail',
    getUnderwriterProfileAsync,
    defaultUnderwriterProfileData
  );
